import React, { useState, useEffect, useRef } from "react";

function Chatbot() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { id: 1, sender: "bot", text: "🤖 MECH_CORE // ONLINE. ZeroPix Autonomous Droid initialized. System optics focused. Awaiting instruction parameters..." }
  ]);
  const chatEndRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, isOpen]);

  const isMobile = windowWidth <= 768;

  const handleOptionClick = (optionType) => {
    let userMsg = "";
    let botMsg = "";

    if (optionType === "about") {
      userMsg = "📡 [UPLINK]: FETCH_METRICS";
      botMsg = "DATA INTEGRITY SECURE: ZeroPix is a premium post-production mainframe engineered in 2024. Processing 24H studio-grade CGI adaptations and cinematic architectural visualizations.";
    } else if (optionType === "order") {
      userMsg = "📡 [UPLINK]: INITIALIZE_PIPELINE";
      botMsg = "DATA INTEGRITY SECURE: Transmit specifications via the global 'Contact' nexus or click 'VIEW OUR WORK'. Internal sensors will automatically harvest your design brief.";
    } else if (optionType === "contact") {
      userMsg = "📡 [UPLINK]: EXTRACT_CHANNELS";
      botMsg = "DATA INTEGRITY SECURE: Core communications available. Mainframe Hub: contact@zeropix.com | Dedicated Comms Secure Line: +91 98765 43210.";
    }

    setMessages((prev) => [...prev, { id: Date.now(), sender: "user", text: userMsg }]);

    setTimeout(() => {
      setMessages((prev) => [...prev, { id: Date.now() + 1, sender: "bot", text: botMsg }]);
    }, 450);
  };

  const styles = {
    // Holographic Circular Floating Mechanical Eye (Trigger Button)
    botFloatingTrigger: {
      position: "fixed",
      bottom: isMobile ? "20px" : "35px",
      right: isMobile ? "20px" : "35px",
      width: "76px",
      height: "76px",
      backgroundColor: "#111111",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      zIndex: 2147483647,
      border: "3px solid #ffcc00",
      boxShadow: "0px 0px 25px rgba(255, 204, 0, 0.6), inset 0px 0px 15px rgba(255, 204, 0, 0.3)",
      transition: "all 0.3s cubic-bezier(0.19, 1, 0.22, 1)",
    },
    triggerInnerIris: {
      width: "36px",
      height: "36px",
      backgroundColor: "#222",
      borderRadius: "50%",
      border: "2px solid #ffcc00",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0px 0px 10px rgba(255, 204, 0, 0.8)",
    },
    // Heavy Armor-Plated Robot Mech Console Layout Chassis
    chatConsoleContainer: {
      position: "fixed",
      bottom: isMobile ? "110px" : "130px",
      right: isMobile ? "20px" : "35px",
      width: isMobile ? "calc(100% - 40px)" : "450px",
      height: "610px",
      backgroundColor: "#16171a", // Gunmetal gray tactical plating background
      border: "4px solid #2a2c33",
      borderRadius: "32px 8px 32px 32px", // Asymmetric mechanical design
      boxShadow: "0px 30px 70px rgba(0, 0, 0, 0.8), 0px 0px 30px rgba(255, 204, 0, 0.1)",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      zIndex: 2147483647,
      animation: "mechPowerOn 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards",
    },
    // Upper Mechanical Sensor Array / Camera Grid Header
    chatTopBarHeader: {
      backgroundColor: "#0f1012",
      padding: "24px",
      display: "flex",
      alignItems: "center",
      gap: "20px",
      borderBottom: "3px solid #ffcc00",
      position: "relative",
    },
    // ENLARGED ULTRA ROBOT CHEST SCREEN DISPLAY (GLOWING MATRIX ZP)
    studioEliteLogo: {
      width: "75px",
      height: "75px",
      backgroundColor: "#111111",
      border: "3px solid #ffcc00",
      borderRadius: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "32px",
      fontWeight: "950",
      color: "#ffcc00",
      letterSpacing: "-1.5px",
      textShadow: "0px 0px 15px rgba(255, 204, 0, 0.9)",
      boxShadow: "0px 0px 20px rgba(255, 204, 0, 0.35), inset 0px 0px 10px rgba(255, 204, 0, 0.2)",
    },
    metaHeaderText: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
    },
    brandMainHeading: {
      color: "#ffffff",
      fontSize: "19px",
      fontWeight: "900",
      letterSpacing: "1.5px",
      textTransform: "uppercase",
    },
    systemActivePulseLabel: {
      color: "#ffcc00",
      fontSize: "10px",
      fontWeight: "800",
      letterSpacing: "2px",
      marginTop: "5px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    terminateConsoleBtn: {
      background: "none",
      border: "none",
      color: "#626875",
      fontSize: "28px",
      cursor: "pointer",
      fontWeight: "300",
      transition: "color 0.2s ease",
    },
    // Core Cyber Display Viewport (Message Logs Screen)
    chatTerminalScroller: {
      flex: 1,
      padding: "24px",
      overflowY: "auto",
      backgroundColor: "#090a0c", // Void tactical viewport shadow dark
      display: "flex",
      flexDirection: "column",
      gap: "18px",
      border: "12px solid #16171a", // Deep inset screen bezel line look
    },
    bubbleEngineBot: {
      alignSelf: "flex-start",
      backgroundColor: "#1e2026",
      color: "#d1d5db",
      padding: "16px 20px",
      fontSize: "14px",
      lineHeight: "1.6",
      maxWidth: "85%",
      borderRadius: "4px 20px 20px 20px",
      borderLeft: "4px solid #ffcc00",
      boxShadow: "0px 5px 15px rgba(0,0,0,0.4)",
    },
    bubbleEngineUser: {
      alignSelf: "flex-end",
      backgroundColor: "#ffcc00",
      color: "#090a0c",
      padding: "14px 18px",
      fontSize: "14px",
      lineHeight: "1.6",
      maxWidth: "85%",
      fontWeight: "800",
      borderRadius: "20px 20px 4px 20px",
      boxShadow: "0px 0px 15px rgba(255, 204, 0, 0.3)",
    },
    // Tactical Terminal Inset Command Grid Footer Layout
    actionOptionsFooterPanel: {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      padding: "20px 24px 26px",
      backgroundColor: "#0f1012",
      borderTop: "2px solid #22252c",
    },
    customActionChipNode: {
      backgroundColor: "#16171a",
      border: "1.5px solid #323742",
      padding: "15px 20px",
      borderRadius: "12px",
      fontSize: "13px",
      fontWeight: "800",
      color: "#a3aed0",
      cursor: "pointer",
      textAlign: "left",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      transition: "all 0.25s cubic-bezier(0.19, 1, 0.22, 1)",
    }
  };

  return (
    <>
      {/* MECH BOOT ENGINES AND ANIMATION CONTROLS SHEET */}
      <style>{`
        @keyframes mechPowerOn {
          from { opacity: 0; transform: translateY(40px) scale(0.93); filter: hue-rotate(-15deg) brightness(0.4); }
          to { opacity: 1; transform: translateY(0) scale(1); filter: hue-rotate(0deg) brightness(1); }
        }
        @keyframes lensRadar {
          0% { box-shadow: 0 0 0 0px rgba(255, 204, 0, 0.5); opacity: 0.8; }
          100% { box-shadow: 0 0 0 20px rgba(255, 204, 0, 0); opacity: 0; }
        }
        .mech-eye-trigger:hover {
          transform: scale(1.1);
          border-color: #ffffff !important;
          box-shadow: 0px 0px 30px rgba(255, 204, 0, 0.8);
        }
        .mech-eye-trigger:hover .iris-node {
          background-color: #ffcc00 !important;
          color: #111 !important;
        }
        .mech-terminal-chip:hover {
          border-color: #ffcc00 !important;
          background-color: #1e2026 !important;
          color: #ffcc00 !important;
          transform: translateY(-2px);
          box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.4);
        }
        .mech-close-trigger:hover {
          color: #ffcc00 !important;
        }
      `}</style>

      {/* COMPACT FLOATING IRIS EYE TRIGGER BUTTON */}
      <div 
        style={styles.botFloatingTrigger} 
        onClick={() => setIsOpen(!isOpen)}
        className="mech-eye-trigger"
      >
        {isOpen ? (
          <span style={{ fontSize: "26px", color: "#ffcc00", fontWeight: "900" }}>✕</span>
        ) : (
          <div style={styles.triggerInnerIris} className="iris-node">
            <span style={{ fontSize: "16px" }}>⚡</span>
            <div style={{ position: "absolute", width: "100%", height: "100%", borderRadius: "50%", animation: "lensRadar 1.8s infinite linear" }}></div>
          </div>
        )}
      </div>

      {/* CORE ACTIVE SCI-FI MECH ROBOT CONSOLE VIEWPORT */}
      {isOpen && (
        <div style={styles.chatConsoleContainer}>
          
          {/* SENSOR HEADER LAYOUT CONTROL AREA */}
          <div style={styles.chatTopBarHeader}>
            {/* LARGE SHARP BRIGHT ROBOT CHEST CORE SCREEN */}
            <div style={styles.studioEliteLogo}>ZP</div>
            
            <div style={styles.metaHeaderText}>
              <span style={styles.brandMainHeading}>ZeroPix Mech-AI</span>
              <span style={styles.systemActivePulseLabel}>
                <span style={{ width: "7px", height: "7px", backgroundColor: "#00ff66", borderRadius: "50%", boxShadow: "0 0 10px #00ff66" }}></span>
                OPTICAL FEED: LOCK_ON
              </span>
            </div>
            
            <button 
              style={styles.terminateConsoleBtn} 
              onClick={() => setIsOpen(false)}
              className="mech-close-trigger"
            >
              ×
            </button>
          </div>

          {/* INNER BEZEL DARK TRANSMISSION SCREEN VIEWPORT */}
          <div style={styles.chatTerminalScroller}>
            {messages.map((msg) => (
              <div 
                key={msg.id} 
                style={msg.sender === "bot" ? styles.bubbleEngineBot : styles.bubbleEngineUser}
              >
                {msg.text}
              </div>
            ))}
            <div ref={chatEndRef} />
          </div>

          {/* INTERACTIVE COMPARTMENT BUTTON TILES */}
          <div style={styles.actionOptionsFooterPanel}>
            <div style={styles.customActionChipNode} className="mech-terminal-chip" onClick={() => handleOptionClick("about")}>
              <span>⚙️ [TELEMETRY] : EXPLORE_STUDIO_METRICS</span>
              <span style={{ color: "#ffcc00", fontWeight: "900" }}>//</span>
            </div>
            <div style={styles.customActionChipNode} className="mech-terminal-chip" onClick={() => handleOptionClick("order")}>
              <span>⚙️ [TELEMETRY] : EXECUTE_PIPELINE_BRIEF</span>
              <span style={{ color: "#ffcc00", fontWeight: "900" }}>//</span>
            </div>
            <div style={styles.customActionChipNode} className="mech-terminal-chip" onClick={() => handleOptionClick("contact")}>
              <span>⚙️ [TELEMETRY] : ENGAGE_COMMS_UPLINK</span>
              <span style={{ color: "#ffcc00", fontWeight: "900" }}>//</span>
            </div>
          </div>

        </div>
      )}
    </>
  );
}

export default Chatbot;